//      
                                          
import config from '../../config';
                                                 

// all in pixels
                                   
                             
                           
   

// converts the percentages in the config into actual pixel values
export default (container      , axis      )                     => {
  const startScrollingFrom         =
    container[axis.size] * config.startFromPercentage;
  const maxScrollValueAt         =
    container[axis.size] * config.maxScrollAtPercentage;

  const thresholds                     = {
    startScrollingFrom,
    maxScrollValueAt,
  };

  return thresholds;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/auto-scroller/fluid-scroller/get-scroll/get-scroll-on-axis/get-distance-thresholds.js